import React from 'react';
import { ScrollView } from 'react-native';
import { useQuery } from '@apollo/client';
import SaleCard from '../../elements/SaleCard';
import { CardContainer, PageTitle } from '../../elements';
import { SALES_WITH_COUNT } from './queries';
import DataState from 'app/src/components/DataState';

const UpcomingSales = props => {

  const { loading, error, data, refetch } = useQuery(
    SALES_WITH_COUNT, { variables: { scopes: ['upcoming', 'ordered'] } }
  );

  return (
    <>
      <PageTitle>Upcoming Sales</PageTitle>
      {loading ?
        <DataState.Loading /> :
        <ScrollView>
          <CardContainer>
            {data?.salesWithCount.entries?.map(sale => {
              return(
                <SaleCard
                  sale={sale}
                  key={`sale${sale.id}`}
                />
              )
            })}
          </CardContainer>
        </ScrollView>
      }
    </>
  )
}

export default UpcomingSales;
